module.exports = __webpack_public_path__ + "img/certificate_example.62260a15.png";